import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { GroupRoleUserDto } from 'projects/shared/src/lib/models/GroupRole';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { ProjectRolesService } from 'projects/shared/src/lib/services/project-roles.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
//import { AgGridUserGroupRolesSettings } from './AgGridUserGroupRolesSettings';
import { MemberGroupRolesButtonRendererComponent } from './member-group-roles-button-renderer/member-group-roles-button-renderer.component';
import { AddUserGroupRoleDialogComponent } from '../add-user-group-role-dialog/add-user-group-role-dialog.component';
import { ProjectGroupRoleUser } from 'projects/shared/src/lib/models/SquirrelRoles';
import { AgGridUserGroupRolesSettings } from './AgGridUserGroupRolesSettings';
import { TenantUserPGR, UserDto } from 'projects/shared/src/lib/models/User';
import { forEach, last } from 'lodash';
import { AccountService } from 'projects/shared/src/lib/services/account.service';

@Component({
  selector: 'member-group-roles-dialog',
  templateUrl: './member-group-roles-dialog.component.html',
  styleUrls: ['./member-group-roles-dialog.component.scss']
    // encapsulation:ViewEncapsulation.None

})
export class MemberGroupRolesDialogComponent implements OnInit {

  groupRoleId!: string;
  groupRoleName!: string;
  //rowDataRoleUser: GroupRoleUserDto[] = [];
  rowData: TenantUserPGR[] = [];
  rowDataAllUsers: TenantUserPGR[] = [];
  rowDataSearchResult: TenantUserPGR[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridUserGroupRolesSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  tenantdb!:string;
  _db!:string;
  _targetIsTenantDB = true;
  userMap: Map<string, TenantUserPGR> = new Map<string, TenantUserPGR>();
  params!: IGetRowsParams;
  isSearchResult: boolean = false;
  isAllUsersLoaded: boolean = true;
  isMemberOnlyLoaded: boolean = false;
  isNonMemberOnlyLoaded: boolean = false;
  emails!: string;
  maxUserCount: number = 0;

  constructor(
    public _dialogRef: MatDialogRef<MemberGroupRolesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    //private projectRoleService: ProjectRolesService,
    private dialog: MatDialog,
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    private accountService: AccountService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this._targetIsTenantDB = this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation;

    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridUserGroupRolesSettings(this.translate);
    console.log("--------> MemberGroupRolesDialogComponent: this.data = ",this.data)
    this.groupRoleName = this.data.roleName;
    this.tenantService.projectId = this.data.projectId;
    this.frameworkComponents = { buttonRenderer: MemberGroupRolesButtonRendererComponent };
    this.gridOptions = this.aggridSettings.agGridUserGroupRolesSettings;

    this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
      next: (tenantDto) => {
        this.maxUserCount = tenantDto.maxUserCount;
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant maxUserCount")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });


    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {
        this.params = params;
        this.filter.className = 'Role';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if(!this._targetIsTenantDB) {      
          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
        }
        else {
          let db:string = this.tenantService.currentTenantName;

        this.tenantService.GetTenantUserPGRList(db, this.data.projectId, this.data.roleId, this.filter).subscribe({
          next: (users:TenantUserPGR[]) => {
           if (users.length > 0) {
              this.rowData = users;
              this.rowDataAllUsers = users;

              console.log("rowDataAllUsers initial loaded: ", this.rowDataAllUsers);

              if (users.length > 0) {
                users.forEach((gru: TenantUserPGR) => {
                  // console.log(">>>>>>>>>>>>>>>>>>>>> gru = ", gru)
                this.userMap.set(gru.email, gru);
                });
              }

              this.rowData = this.rowData.slice(params.startRow, params.endRow);
              console.log(">>>>>>>>>>>>>>>>>>>>> rowData (users) = ", this.rowData)
              let lastRow = -1;
  
              if (users.length <= params.endRow) {
                lastRow = users.length;
              }
              params.successCallback(this.rowData, lastRow);
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
              //this.resultsLength = this.rowData.length;
  
              this.gridApi.hideOverlay();
            } else { // no user
            }
          }
        })
          error: (error: any) => {
            // this.isLoadingResults = false;
            // this.isRateLimitReached = true;
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
          }
        }
      }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds)
  } 

  cancel(){
    console.log(">>>>>>>>>>>>>>>>>>>>> rowData (users) at end = ", this.rowDataAllUsers)
    this.notificationService.warning(`${this.translate.data["WARN"]}`, "Mögliche Änderungen wurden verworfen");

    this._dialogRef.close();
  }

  saveData(){
    console.log(">>>>>>>>>>>>>>>>>>>>> rowData (users) at save = ", this.rowDataAllUsers)
    let inclTGR: boolean = false;
    let copyUserId: string = 'undefined';
    let userDto: UserDto = new UserDto();
    let numberOfnewUsers: number = 0;
    let numberOfChangedUsers: number = 0;
    let numberOfAddedUsers: number = 0;
    let numberOfRemovedUsers: number = 0;
    
    this.rowDataAllUsers.forEach( user => {
      let projRolePairs: string[] = [];
      if(user.isRoleMember){
        projRolePairs.push( this.tenantService.projectId + '|' + this.data.roleId + '|' + this.data.roleName);
      }
      if(user.isNew){
        numberOfnewUsers++;
        userDto.email = user.email;
        // userDto.userName = user.userName;
        // userDto.id = user.userId;
        // console.log(">>>>>>>>>>>>>>>>>>>>> createUserWithPermissions: userDto = ", userDto)
        this.accountService.createUserWithPermissions(/*isTenantAdmin:*/ false, inclTGR, copyUserId, userDto, projRolePairs,
                                                  this.tenantService.currentTenantName, this.tenantService.tempTenantId).subscribe({
          next: (user) => {
              let projectGroupRoleUser: ProjectGroupRoleUser = new ProjectGroupRoleUser();
              projectGroupRoleUser.userId = user.id;
              projectGroupRoleUser.userName = (user.userName != '') ? user.userName : user.email;
              projectGroupRoleUser.email = user.email;
              projectGroupRoleUser.roleId = this.data.roleId;
              projectGroupRoleUser.roleName = this.data.roleName;
              projectGroupRoleUser.projectId = this.data.projectId;
              projectGroupRoleUser.tenantId = this.tenantService.currentTenantId;
              this.tenantService.createProjectGroupRoleUser(projectGroupRoleUser, this.tenantService.tempTenantName).subscribe({
                next:(projectGroupRoleUser) => {
                  // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEUSERCREATED"]} `);
                },
                error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RPROJECTGROUPROLEUSERCREATEDERROR"]}`)
              });
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
        });
      } else if(user.isChanged){
        numberOfChangedUsers++;
        if(user.isRoleMember){
          numberOfAddedUsers++;
          let projectGroupRoleUser: ProjectGroupRoleUser = new ProjectGroupRoleUser();
          projectGroupRoleUser.userId = user.userId;
          projectGroupRoleUser.userName = (user.userName != '') ? user.userName : user.email;
          projectGroupRoleUser.email = user.email;
          projectGroupRoleUser.roleId = this.data.roleId;
          projectGroupRoleUser.roleName = this.data.roleName;
          projectGroupRoleUser.projectId = this.data.projectId;
          projectGroupRoleUser.tenantId = this.tenantService.currentTenantId;
          this.tenantService.createProjectGroupRoleUser(projectGroupRoleUser, this.tenantService.tempTenantName).subscribe({
            next:(projectGroupRoleUser) => {
              // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEUSERCREATED"]} `);
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["RPROJECTGROUPROLEUSERCREATEDERROR"]}`)
          });
        } else {
          numberOfRemovedUsers++;
          this.tenantService.deleteUserFromGroupRole(this.tenantService.tempTenantName, this.data.projectId, this.data.roleId, user.userId).subscribe({
            next: () => {
              // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLE"]}`);
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERREMOVEDFROMGROUPROLEERROR"]}`)
          });
        }
      }
    })
    // this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["PROJECTGROUPROLEUSERCREATED"]} `);
    if(numberOfnewUsers > 0 || numberOfChangedUsers > 0) {
      const toastParts: string[] = [];
      if (numberOfAddedUsers > 0) toastParts.push(`${numberOfAddedUsers} Benutzer zur Gruppenrolle hinzugefügt.\n`);
      if (numberOfRemovedUsers > 0) toastParts.push(`${numberOfRemovedUsers} Benutzer aus Gruppenrolle entfernt.`);
      if (numberOfnewUsers > 0) toastParts.push(`${numberOfnewUsers} neue Benutzer eingeladen und zur Gruppenrolle hinzugefügt.`);
      // Mit Zeilenumbruch
      //const toast = toastParts.join('\n');
      // Falls der Notification-Service HTML erwartet, alternativ:
      //const toast = toastParts.join('<br/>');

      this.notificationService.successHtml(`${this.translate.data["SUCCESS"]}`, toastParts.join('<br/>'));
      this.notificationService.success(`${this.translate.data["SUCCESS"]}`, "Änderungen erfolgreich übernommen");
    }
    else
      this.notificationService.info(`${this.translate.data["INFO"]}`, "Keine Änderungen zum Speichern vorhanden");
    this._dialogRef.close(this.rowDataAllUsers);
  }

  refresh(){
    let lastRow = -1;
    if (this.rowData.length <= this.params.endRow) {
      lastRow = this.rowData.length;
    }
    if (lastRow === 0) { // damit bei Folgeaufrufen params.successCallback funktioniert
      lastRow = 1;      
    }
    this.params.successCallback(this.rowData, lastRow);
  }

  addUserToGroupRole(){

    // console.log("addUserToGroupRole: rowData=", this.rowData);
    // console.log("addUserToGroupRole: rowDataAllUsers=", this.rowDataAllUsers);

    if (this.isSearchResult) {
      this.rowData = this.rowDataSearchResult;
    } else {
      //this.rowData = this.rowDataAllUsers;
    }
    // console.log("addUserToGroupRole: rowData=", this.rowData);

    let tempData: TenantUserPGR[] = [];
    tempData.push(...this.emails.split(/[\s,;]+/).map(email => {
      const newUser: TenantUserPGR = {
        userName: "(not confirmed)",
        email: email,
        isRoleMember: true,
        userId: '',
        isChanged: false,
        isNew: true,
        tenantId: this.tenantService.currentTenantId,
        tenantName: this.tenantService.currentTenantName,
        projId: this.data.projectId,
        roleId: this.data.roleId,
        roleName: this.data.roleName,
        copyUserId: '',
        inclTGR: false,
        isTenantAdmin: false
      };
      return (newUser.email != '') ? newUser : null as any;
    }));

    if (tempData[tempData.length - 1] == null)
      tempData.pop(); // letztes leeres Element entfernen, weil null erzeugt wird, wenn nach dem letzten Trennzeichen noch ein Leerzeichen ist
    //this.rowData.push(...tempData); alle auf einmal geht nicht, weil sonst Doupletten entstehen, also einzeln hinzufügen

    if (tempData.length + this.rowDataAllUsers.length > this.maxUserCount) {
      this.notificationService.error("", `Die maximale Benutzeranzahl von ${this.maxUserCount} wird überschritten!`);
      return;
    } else
        this.emails = ''; // Textarea leeren


    tempData.forEach( newUser => {
      // prüfen, ob der User schon in der Liste ist
      let existingUser = this.rowDataAllUsers.find( user => user.email === newUser.email);
      if(!existingUser){
        this.rowData.push(newUser);
        this.rowDataAllUsers.push(newUser);
      } else {
        //console.log("addUserToGroupRole: User already exists: ", existingUser);
        let tempUser = existingUser;
        tempUser.isRoleMember = true;
        tempUser.isChanged = true;
        tempUser.isNew = false;
        // bestehenden User durch newUser mit entsprechenden Flags ersetzen (in sichtbaren und in allen Daten)
        const idxVisible = this.rowData.findIndex(u => u.email === newUser.email);
        if (idxVisible > -1) {
          this.rowData[idxVisible] = tempUser;
        }

        const idxAll = this.rowDataAllUsers.findIndex(u => u.email === newUser.email);
        if (idxAll > -1) {
          this.rowDataAllUsers[idxAll] = tempUser;
        } else {
          // Falls aus irgendeinem Grund nicht in rowDataAllUsers vorhanden, hinzufügen
          this.rowDataAllUsers.push(tempUser);
        }
      }
    });

    // console.log("addUserToGroupRole: rowData=", this.rowData);


    if (this.isNonMemberOnlyLoaded) {
      //this.rowDataAllUsers = this.rowDataAllUsers.concat(tempData);
      this.rowData = this.rowDataAllUsers.filter(user => !user.isRoleMember);
      this.rowDataSearchResult = this.rowData;
    } else if (this.isMemberOnlyLoaded) {
      //this.rowDataAllUsers = this.rowDataAllUsers.concat(tempData);
      this.rowData = this.rowDataAllUsers.filter(user => user.isRoleMember);
      this.rowDataSearchResult = this.rowData;
    }
    this.refresh();
  }

  onFilterTextBoxChanged(selectString: string) {
    console.log("onFilterTextBoxChanged: searchStr=", selectString);
    if (this.isSearchResult) {
      this.rowData = this.rowDataSearchResult.filter(user => 
        user.userName!.toLowerCase().includes(selectString.toLowerCase()) || 
        user.email!.toLowerCase().includes(selectString.toLowerCase())
      );
    } else {
      this.rowData = this.rowDataAllUsers.filter(user => 
        user.userName!.toLowerCase().includes(selectString.toLowerCase()) || 
        user.email!.toLowerCase().includes(selectString.toLowerCase())
      );
    }
    this.refresh();
  }

  search(stringFilter:string){
    console.log("search: stringFilter=", stringFilter);
    switch (stringFilter) {
      case "ALL_USERS": {
        this.isSearchResult = false;
        this.isAllUsersLoaded = true;
        this.isMemberOnlyLoaded = false;
        this.isNonMemberOnlyLoaded = false;
        this.rowData = this.rowDataAllUsers;
        break;
      }
      case "ONLY_MEMBERS": {
        this.isSearchResult = true;
        this.isAllUsersLoaded = false;
        this.isMemberOnlyLoaded = true;
        this.isNonMemberOnlyLoaded = false;
        this.rowData = this.rowDataAllUsers.filter(user => user.isRoleMember);
        this.rowDataSearchResult = this.rowData;
        break;
      }
      case "NON_MEMBERS": {
        this.isSearchResult = true;
        this.isAllUsersLoaded = false;
        this.isMemberOnlyLoaded = false;
        this.isNonMemberOnlyLoaded = true;
        this.rowData = this.rowDataAllUsers.filter(user => !user.isRoleMember);
        // this.rowData = this.rowData.slice(this.params.startRow, this.params.endRow);
        this.rowDataSearchResult = this.rowData;
        break;
      }
      default: {
        console.log("search: unbekannte Aktion = ", stringFilter);
        break;
      }
    }
      this.refresh();
  }
}




